import { render, staticRenderFns } from "./TicketsFAQGroup.vue?vue&type=template&id=c523f32a&"
import script from "./TicketsFAQGroup.vue?vue&type=script&lang=js&"
export * from "./TicketsFAQGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports